(function () {
  const SELECTOR   = 'form.easylockdown-price-holder';
  const LOGIN_URL  = '/account/login';
  const LINK_TEXT  = 'LOGIN TO VIEW PRICING';
  const LINK_CLASS = 'easylockdown-custom-link';

  function buildLoginUrl() {
    const returnTo = window.location.pathname + window.location.search;
    return LOGIN_URL + '?checkout_url=' + encodeURIComponent(returnTo);
  }

  function addLink(holder) {
    const next = holder.nextElementSibling;
    if (next && next.classList.contains(LINK_CLASS)) return;

    const a = document.createElement('a');
    a.href = buildLoginUrl();
    a.textContent = LINK_TEXT;
    a.className = LINK_CLASS;

    a.addEventListener('click', () => { a.href = buildLoginUrl(); });

    holder.insertAdjacentElement('afterend', a);
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(SELECTOR)) addLink(node);
    node.querySelectorAll(SELECTOR).forEach(addLink);
  }

  function init() {
    scan(document.body);
    new MutationObserver(mutations => {
      mutations.forEach(m => m.addedNodes.forEach(scan));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();